* {
  box-sizing: border-box;
}

:host {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 calc(var(--spacer) * 2);
  max-width: 100%;
  overflow: hidden;
}

.footer {
  height: 56px;
  width: 100%;
}

.content {
  overflow: auto;

  & > * {
    height: auto;
    display: block;
    margin-top: var(--spacer);
    margin-bottom: calc(var(--spacer) * 2);

    &:not(:last-child) {
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
    }
  }
}
